import TimeIcon from '@mui/icons-material/Schedule'
import PPSelect, { PPSelectOptions } from 'components/PPSelect'
import {
  ALL_RANGE_FILTER,
  MONTH_RANGE_FILTER,
  NEW_RANGE_FILTER,
  RangeFilter,
  THREE_DAYS_RANGE_FILTER,
  WEEK_RANGE_FILTER,
  YEAR_RANGE_FILTER
} from 'interfaces'
import { useMemo } from 'react'
import { FormattedMessage } from 'react-intl'

const OPTIONS = [
  { value: NEW_RANGE_FILTER, label: 'new' },
  { value: THREE_DAYS_RANGE_FILTER, label: '3 days' },
  { value: WEEK_RANGE_FILTER, label: 'week' },
  { value: MONTH_RANGE_FILTER, label: 'month' },
  { value: YEAR_RANGE_FILTER, label: 'year' },
  { value: ALL_RANGE_FILTER, label: 'all' }
] as { value: RangeFilter, label: string }[]

export interface RangeFilterSelectProps {
  range: RangeFilter
  hideNew?: boolean
  onRangeSelected(range: RangeFilter): void
}

export function RangeFilterSelect(props: RangeFilterSelectProps) {
  const options = useMemo(() => props.hideNew ? OPTIONS.slice(1) : OPTIONS, [props.hideNew])
  const formattedOptions: PPSelectOptions = options.reduce((map: PPSelectOptions, o, index) => {
    map[o.value] = {
      label: <FormattedMessage id={`general.content.ranges.${o.value}`} />,
      order: index + 1
    }
    return map
  }, {})

  return (
    <PPSelect
      options={formattedOptions}
      selectedValue={props.range}
      withCaret
      id="time-range-select"
      icon={<TimeIcon />}
      onSelectionChange={props.onRangeSelected}
    />
  )
}

export default RangeFilterSelect
